import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fileUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { PageHeader, assetTypeLabel, fmtDateTime, trackingUnit, EmptyState } from "@/components/shared";
import { Truck, Package, Cpu, Gauge, Calendar } from "lucide-react";

const typeIcon = { mezzo: Truck, attrezzatura: Package, dispositivo: Cpu };

export default function MyAssets() {
  const { user } = useAuth();
  const [assets, setAssets] = useState([]);

  useEffect(() => { api.get("/my/assets").then(({ data }) => setAssets(data)); }, []);

  return (
    <div>
      <PageHeader eyebrow={`Ciao ${user?.name?.split(" ")[0] || ""}`} title="Le mie dotazioni" subtitle="I beni aziendali a te assegnati" />

      {assets.length ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {assets.map((a) => {
            const Icon = typeIcon[a.asset_type] || Package;
            const unit = trackingUnit(a.tracking_type);
            return (
              <Card key={a.id} data-testid={`my-asset-${a.id}`} className="p-5 rounded-lg">
                <div className="flex items-start justify-between mb-3">
                  <div className="h-14 w-14 rounded-md bg-primary/10 overflow-hidden flex items-center justify-center">
                    {a.image ? (
                      <img src={fileUrl(a.image)} alt={a.name} className="h-full w-full object-cover" />
                    ) : (
                      <Icon className="h-6 w-6 text-primary" />
                    )}
                  </div>
                  <span className="label-caps text-muted-foreground">{assetTypeLabel(a.asset_type)}</span>
                </div>
                <div className="font-heading font-bold text-lg">{a.name}</div>
                <div className="text-sm text-muted-foreground">{a.brand} {a.model}</div>
                {a.identifier && <div className="font-mono text-sm mt-1">{a.identifier}</div>}
                <div className="flex items-center gap-4 mt-4 pt-3 border-t border-border text-sm">
                  {a.tracking_type !== "nessuno" && (
                    <span className="flex items-center gap-1.5 text-muted-foreground"><Gauge className="h-4 w-4" />{a.current_value || 0} {unit}</span>
                  )}
                  <span className="flex items-center gap-1.5 text-muted-foreground"><Calendar className="h-4 w-4" />{fmtDateTime(a.assigned_date)}</span>
                </div>
              </Card>
            );
          })}
        </div>
      ) : (
        <Card className="rounded-lg"><EmptyState icon={Package} title="Nessuna dotazione" subtitle="Al momento non hai beni assegnati." /></Card>
      )}
    </div>
  );
}
